import { render, staticRenderFns } from "./ResourceRow.vue?vue&type=template&id=03e29f5f&scoped=true&"
import script from "./ResourceRow.vue?vue&type=script&lang=js&"
export * from "./ResourceRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e29f5f",
  null
  
)

export default component.exports